import { render, staticRenderFns } from "./productAttrPopup.vue?vue&type=template&id=ace6acb6&scoped=true&"
import script from "./productAttrPopup.vue?vue&type=script&lang=js&"
export * from "./productAttrPopup.vue?vue&type=script&lang=js&"
import style0 from "./productAttrPopup.vue?vue&type=style&index=0&id=ace6acb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace6acb6",
  null
  
)

export default component.exports